import { TimeSlot as Slots } from '@homeserve/od-typings/api';
import { TimeSlot, PriceOption, slots } from '../components/WLFixAppointment/interfaces';
import moment, { Moment } from 'moment';
import { isAppointmentAtNightOrSaturday, isAppointmentOnSundayOrHoliday } from '../components/WLFixAppointment/utils';

export function minutesToHumanDuration(minutes: number) {
  return minutes > 60
    ? minutes % 60 === 0
      ? Math.floor(minutes / 60) + 'h'
      : Math.floor(minutes / 60) + 'h' + (minutes % 60)
    : minutes + ' min';
}

export function getCurrentSlot(): TimeSlot {
  const now = moment();

  const slotResult: TimeSlot = {
    cost: PriceOption.customerBasePurchasePrice,
    date: now,
    slot: Slots.AM,
  };

  if (isMorning(now)) {
    slotResult.slot = Slots.AM;
  } else if (isAfternoon(now)) {
    slotResult.slot = Slots.PM;
  } else {
    slotResult.cost = PriceOption.customerExtraChargeNights;
    slotResult.slot = Slots.EVENING;
  }

  if (isAppointmentAtNightOrSaturday(now)) {
    slotResult.cost = PriceOption.customerExtraChargeNights;
  } else if (isAppointmentOnSundayOrHoliday(now)) {
    slotResult.cost = PriceOption.customerExtraChargeSundays;
  }
  return slotResult;
}

export function isMorning(date: Date | Moment) {
  return moment(date).isBetween(
    moment(date).set({
      hour: slots.am.start,
      minute: 0,
      second: 0,
      millisecond: 0,
    }),
    moment(date).set({
      hour: slots.am.end,
      minute: 0,
      second: 0,
      millisecond: 0,
    }),
  );
}

export function isAfternoon(date: Date | Moment) {
  return moment(date).isBetween(
    moment(date).set({
      hour: slots.pm.start,
      minute: 0,
      second: 0,
      millisecond: 0,
    }),
    moment(date).set({
      hour: slots.pm.end,
      minute: 0,
      second: 0,
      millisecond: 0,
    }),
  );
}

export const timeSlotToDate = (date: Moment, slot: Slots): Moment => {
  return date.set({
    hour: slots[slot].end,
    minute: 0,
    second: 0,
  });
};

export const isAppointmentInThePast = (timeSlot: TimeSlot) => {
  const { date, slot } = timeSlot;

  if (!date || !slot) {
    return false;
  }

  const now = moment();
  const appointmentDate = timeSlotToDate(date, slot);

  return appointmentDate.isBefore(now);
};
